export const SUPPORTED_LOCALES = [
    { code: 'en', label: 'English', IETF: 'en-US' },
    { code: 'fr', label: 'Français', IETF: 'fr-FR' },
] as const;

export type SupportedLocaleObject = (typeof SUPPORTED_LOCALES)[number];
export type SupportedLocaleCode = SupportedLocaleObject['code'];
export type SupportedLocaleLabel = SupportedLocaleObject['label'];
export type SupportedLocaleIETF = SupportedLocaleObject['IETF'];

export const DEFAULT_LOCALE: SupportedLocaleCode = 'fr';
export const FALLBACK_LOCALES: {
    [k in SupportedLocaleCode]: SupportedLocaleCode;
} = {
    en: 'fr',
    fr: 'en',
} as const;

export const getLanguageLabel = (language: string) => {
    return SUPPORTED_LOCALES.find((locale) => locale.code === language)?.label;
};

export const getLanguageIETF = (language: string) => {
    return SUPPORTED_LOCALES.find((locale) => locale.code === language)?.IETF;
};

export const SUPPORTED_LOCALES_SET = new Set(
    SUPPORTED_LOCALES.map((locale) => locale.code),
);

export const isSupportedLocaleCode = (
    code: string,
): code is SupportedLocaleCode => {
    return SUPPORTED_LOCALES_SET.has(code as SupportedLocaleCode);
};
